import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
export default {
  name: "mBtnMpay",
  props: {
    isNoStyle: {
      default: false
    },
    type: {
      default: "COIN"
    }
  },
  computed: {
    ...userVuex.mapState(["userInfo", "settingInfo", "balanceInfo", "first_adv"])
  },
  data() {
    return {
      popPromptInfo: null,
      popPromptShow: false
    };
  },
  watch: {
    popPromptShow: {
      handler(bool) {
        if (!bool) {
          this.popPromptInfo.error = null;
          this.popPromptInfo.cancelText = null;
        }
      }
    }
  },
  methods: {
    ...userVuex.mapMutations(["setFirstAdv"]),
    async showPop() {
      await this.setPopPromptInfo();
      this.popPromptShow = true;
    },
    setPopPromptInfo() {
      this.popPromptInfo = {
        icon: "https://static.humanpass.net/202511/25/70a3610f-8ee8-4b07-a9df-628619f74936.png",
        confirmText: "Activate VISA",
        confirmFn: async () => {
          this.WebApp.openTelegramLink(`https://t.me/MpayCardBot/app?startapp=ref_2cTzS6`);
        },
        isSmallConfirmBtn: false,
        //claim出现时 confirm 按钮比例小一点
        isCancelLoading: false //claim按钮 loading状态
      };
    },

    openUrl() {
      this.WebApp.openTelegramLink(`https://t.me/HumanPassAi`);
    }
  },
  mounted() {
    if (!this.first_adv) {
      this.setFirstAdv(true);
      this.showPop();
    }
  }
};